<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-file-document-edit-outline</v-icon>{{$t('qualitycheck.product.producttypefiletypes')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <ProducttypefiletypeForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import ProducttypefiletypeForm from '../../components/producttypefiletype/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'Producttypefiletype';

const { mapFields } = createHelpers({
  getterType: 'producttypefiletype/getField',
  mutationType: 'producttypefiletype/updateField'
});

export default {
  name: 'ProducttypefiletypeCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    ProducttypefiletypeForm
  },
  data() {
    return {
      item: {}
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('producttypefiletype', ['create', 'reset'])
  }
};
</script>
